module.exports = __webpack_public_path__ + "static/media/gameplay_bg_b_04.badcf618.png";